module.exports = __webpack_public_path__ + "img/home_btn.cff07c68.png";